import React from 'react';
import { Field, FieldProps } from 'formik';
import ActivateDeactivateToggle from '../ActiveDeactivateToggle';

interface IProps {
    text: string;
    name: string;
    disabled?: boolean;
}

export const FormikRuleToggle: React.FunctionComponent<IProps> = ({ text, name, disabled = false }) => {
    return (
        <Field name={name}>
            {({ field, form }: FieldProps) => {
                const interaction = () => {
                    form.setFieldValue(field.name, !field.value);
                    form.setFieldTouched(field.name, true);
                };

                return (
                    <ActivateDeactivateToggle
                        name={name}
                        text={text}
                        checked={field.value}
                        disabled={disabled}
                        handleChangeCallback={interaction}
                        handleKeyDown={interaction}
                        dataTestId={`${name}-toggle`}
                    />
                );
            }}
        </Field>
    );
};
